export enum Colors {
  White = 'white',
  DarkGrey = 'dark-grey',
  LightGrey = 'light-grey',
  OffWhite = 'off-white',
  Black = 'black',
}
